<app-sidenav [className]="'h-full'" [padding]="0" [title]="title">
  <div class="flex flex-column gap-3 align-items-center">
    <mat-nav-list cdkFocusRegionstart class="w-full p-0">
      <div *ngFor="let item of menu; trackBy: trackByMenuItem">
        <mat-divider *ngIf="item.separator" class="mx-3"></mat-divider>
        <app-menu-item [menuItem]="item" *ngIf="item.visible!=false"></app-menu-item>
      </div>
    </mat-nav-list>
  </div>
  <div footer>
    <div class="flex justify-content-between text-xs font-light text-color-secondary">
      <div>
        {{author() | uppercase}}
      </div>
      <div>
        {{version() | lowercase}}
      </div>
    </div>
  </div>
</app-sidenav>
